import { lazy } from 'react';

import { ProtectedRoute } from '../../components/ProtectedRoute';
import { UnauthorizedRoute } from '../../components/UnauthorizedRoute';
import { RoutePath } from '../../constants';
import { RouteProps } from '../../routes/types';
import lazyRetry from '../../utils/lazyFetch';

const Forbidden = lazy(() => lazyRetry(() => import('../../pages/Forbidden'), 'Forbidden'));
const ForgotPassword = lazy(() => lazyRetry(() => import('../../pages/ForgotPassword'), 'ForgotPassword'));
const Login = lazy(() => lazyRetry(() => import('../../pages/Login'), 'Login'));
const Logout = lazy(() => lazyRetry(() => import('../../pages/Logout'), 'Logout'));
const NotAssigned = lazy(() => lazyRetry(() => import('../../pages/NotAssigned/NotAssigned'), 'NotAssigned'));
const NotFound = lazy(() => lazyRetry(() => import('../../pages/NotFound'), 'NotFound'));
const OrgSwitcher = lazy(() => lazyRetry(() => import('../../pages/OrgSwitcher'), 'OrgSwitcher'));
const ResendInvite = lazy(() => lazyRetry(() => import('../../pages/ResendInvite'), 'ResendInvite'));
const SetPassword = lazy(() => lazyRetry(() => import('../../pages/SetPassword'), 'SetPassword'));

export const commonMarketerAppRoutes: RouteProps[] = [
  {
    path: RoutePath.LOGIN,
    element: <UnauthorizedRoute children={<Login />} />,
  },
  {
    path: RoutePath.LOGOUT,
    element: <ProtectedRoute children={<Logout />} />,
  },
  {
    path: RoutePath.ORG_SWITCHER,
    element: <ProtectedRoute children={<OrgSwitcher />} />,
  },
  {
    path: RoutePath.SET_PASSWORD,
    element: <UnauthorizedRoute children={<SetPassword />} />,
  },
  {
    path: RoutePath.RESEND_INVITE,
    element: <UnauthorizedRoute children={<ResendInvite />} />,
  },
  {
    path: RoutePath.FORGOT_PASSWORD,
    element: <UnauthorizedRoute children={<ForgotPassword />} />,
  },
  {
    path: RoutePath.FORBIDDEN,
    element: <Forbidden />,
  },
  {
    path: RoutePath.NOT_FOUND,
    element: <NotFound />,
  },
  {
    path: RoutePath.NOT_ASSIGNED,
    element: <ProtectedRoute children={<NotAssigned />} />,
  },
];
